import { DatePicker, TimePicker, TimePickerProps } from 'antd';
import React, { useEffect, useState } from 'react'
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs, { Dayjs } from "dayjs";
import Select, { StylesConfig } from "react-select";
import TextField from '../../../../core/common/textFields/TextField';
import { useGetAllActiveUsersQuery, useGetSaleInfoByIdQuery, useUpsertSaleInfoDetailsMutation } from '../../../../services/EndPointsApis';
import { useFormik } from 'formik';
import ModalComponent from '../../../../core/common/modal/ModalComponent';
import { toast } from 'react-toastify';
import FormattedNumber from '../../../../core/common/textFields/FormatNumber';
import { svgIcons } from '../../../../style/fonts/SvgIcons';


const SalesInfoWizardData = ({ saleInfoTrigger, getallActiveUsers, projectLookups, setSaleInfoData, storeProjectId, setTotalAmount, formik, remainingAmount, setRemainingAmount }: any) => {

  const [paymentType, setPaymentType] = useState({ id: 0, value: "" });
  const [paymentAmt, setPaymentAmt] = useState("");
  const [showModal, setShowModal] = useState(false);
  //use for dynamic desription in nweEntry am creating in handleTableChange , when the payment type is other 
  const [paymentDescription, setPaymentDescription] = useState("");
  const [concatPaymentDescription, setConcatPaymentDescription] = useState("");
  const [paymentDate, setPaymentDate] = useState<Dayjs | null>(null);

  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
  };
  dayjs.extend(customParseFormat);

  //Get Sale Info
  const { data: saleInfoData, refetch } = useGetSaleInfoByIdQuery({ ProjectId: storeProjectId })

  const formatNumber = (value: any) =>
    value ? Number(value).toFixed(2) : "0";
  const [remainingAmountFormatted, setRemainingAmountFormatted] = useState(0);

  //GetSaleInfoById

  // useEffect(() => {
  //   setSaleInfoData(saleInfoData)
  //   if (!formik.values.projectPaymentSchedule?.length && saleInfoData?.result?.projectPaymentSchedule) {
  //     formik.setValues({
  //       ...formik.values,
  //       projectPaymentSchedule: saleInfoData.result.projectPaymentSchedule.map((item: any) => ({
  //         ...item,
  //         newAmount: item.newAmount || 0,
  //       })),
  //     });
  //   }
  // }, [saleInfoData]);


  useEffect(() => {
    if (saleInfoTrigger === false && saleInfoData?.result && Object.keys(saleInfoData?.result).length > 0) {
      formik.setValues(saleInfoData?.result);
    } else {
      // setUpdateId(0);
    }
  }, [saleInfoData, saleInfoTrigger]);



  const handleDateChange = (date: Dayjs | null) => {
    // setSelectedFreshAptDate(date);
    formik.setFieldValue('saleDate', date ? date.format('YYYY-MM-DD') : null);
  };

  useEffect(() => {
    formik.setFieldValue(
      "totalContractAmt",
      (Number(formik?.values?.salePrice) || 0) + (Number(formik?.values?.totalAdendum) || 0)
    );
  }, [formik.values]);

  useEffect(() => {
    refetch()
  }, [])

  const fullAmount = formik.values?.salePrice

  useEffect(() => {
    const total = formik?.values?.projectPaymentSchedule?.reduce(
      (sum: any, item: any) => sum + (item?.newAmount || 0),
      0
    ) || 0;
    // const totalAmount = formatNumber(total)
    setTotalAmount(total);
    formik.setFieldValue("totalPaymentAmt", total);
    // const remaining = (totalContractAmount + (formik?.values?.saleAmount || 0)) - total;
    const remaining = formik.values.totalContractAmt - total;
    const remainingFormatted = new Intl.NumberFormat("en-US").format(remaining);
    setRemainingAmount(remainingFormatted);
    setRemainingAmountFormatted(remaining)
    formik.setFieldValue("remainingAmount", remainingAmount);
  }, [formik.values, setRemainingAmount, setTotalAmount]);


  const handleTableChange = () => {
    // Check if payment type and amount are valid
    if (!paymentType.id || !paymentAmt || (paymentType?.id === 13 && !paymentDescription) || (paymentType.id === 12 && ((!paymentDate || !paymentDate?.isValid?.()) || !paymentDescription)) || parseFloat(paymentAmt) === 0) {
      toast.error('Please fill all the fields.');
      return;
    }
    const maxOrderId = formik.values.projectPaymentSchedule.reduce(
      (max: number, entry: any) => Math.max(max, entry.orderId || 0),
      0
    );

    const newOrderId = maxOrderId + 1;
    // Create a new entry
    const newEntry = {
      id: "00000000-0000-0000-0000-000000000000",
      projectId: storeProjectId,
      orderId: newOrderId,
      childId: storeProjectId,
      // lst_PaymentType: paymentType,
      lst_PaymentType: paymentType.value === "Other"
        ? {
          ...paymentType,
          value: `Other - ${paymentDescription}`
        }
        : paymentType.value === "On Date"
          ? {
            ...paymentType,
            value: `On Date - ${concatPaymentDescription}`
          } : paymentType,

      paymentAmt: 0,
      newAmount: parseFloat(paymentAmt),
      changeBy: parseFloat(paymentAmt),
      lst_CreatedBy: { id: 0, value: "" },
      lst_Modified: { id: 0, value: "" },
      createdDT: new Date().toISOString(),
      modifiedDT: new Date().toISOString(),
      ...(paymentType?.value === "Other" && { description: paymentDescription }),
      ...(paymentType?.value === "On Date" && {
        description: concatPaymentDescription,
      }),
    };

    const filteredSchedule = formik.values.projectPaymentSchedule.filter(
      (entry: any) => entry.id !== "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    );

    formik.setFieldValue("projectPaymentSchedule", [
      ...filteredSchedule,
      newEntry,
    ]);
    // Reset local states
    setPaymentType({ id: 0, value: "" });
    setPaymentAmt("");
    setPaymentDescription("");
    setConcatPaymentDescription("");
    setPaymentDate(null)
  };

  const handleReset = () => {
    formik.setValues({
      ...formik.values,
      projectPaymentSchedule: [],
    });
  }
  const handleSalePriceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value.replace(/,/g, "");
    if (/^\d*$/.test(inputValue)) {
      formik.setFieldValue("salePrice", Number(inputValue));
    }
  };
  const handleSalePriceBlur = () => {
    const raw = parseFloat(formik.values.salePrice);
    if (!isNaN(raw)) {
      formik.setFieldValue('salePrice', raw.toFixed(2));
    }
  };

  const formatComma = (num: number | string) => {
    if (num === null || num === undefined) return "0.0";
    const numericValue = String(num).replace(/,/g, "");
    if (isNaN(Number(numericValue))) return String(num);
    return Number(numericValue).toLocaleString();
  };

  const disbaleAddPayment = saleInfoData?.result?.projectPaymentSchedule.length > 0

  type OptionType = {
    label: string;
    value: number;
  };

  const maxOrderId = formik?.values?.projectPaymentSchedule?.length
    ? Math.max(...formik?.values?.projectPaymentSchedule?.map((item: any) => item.orderId + 1))
    : 0;
  const optionsOrderId: OptionType[] = Array.from({ length: maxOrderId }, (_, i) => ({
    label: `${i + 1}`,
    value: i + 1,
  }));
  const isDuplicateOrderId = formik?.values?.projectPaymentSchedule?.length !== new Set(formik.values?.projectPaymentSchedule?.map((i: { orderId: any; }) => i?.orderId))?.size;
  const handleOrderIdChange = (index: number, newOrderId: number) => {
    const currentValues = [...formik.values?.projectPaymentSchedule];
    const movedItem = currentValues[index];

    // Remove item from its current position
    currentValues.splice(index, 1);

    // Insert at new position (newOrderId - 1 because array is 0-indexed)
    currentValues.splice(newOrderId - 1, 0, movedItem);

    // Reassign orderId based on new index
    const updatedValues = currentValues.map((item, i) => ({
      ...item,
      orderId: i + 1,
    }));

    formik.setFieldValue("projectPaymentSchedule", updatedValues);
  };
  const handleDeleteEntry = (orderIdToDelete: number) => {
    const updatedValues = formik.values.projectPaymentSchedule?.filter(
      (entry: any) => entry.orderId !== orderIdToDelete
    );
    const reordered = updatedValues.map((entry: any, index: number) => ({
      ...entry,
      orderId: index + 1,
    }));
    formik.setFieldValue("projectPaymentSchedule", reordered);

  };
  return (
    <>
      <div className='row mt-2'>
        <>
          <div className="col-md-12">
            <label className="input-label">
              Start Date <span className="text-danger">*</span>
            </label>
            <div className="form-wrap icon-form">
              <span className="form-icon">
                <i className="ti ti-calendar-check" />
              </span>
              <DatePicker
                className="form-control datetimepicker deals-details"
                onChange={handleDateChange}
                disabled={saleInfoData?.result?.saleDate !== null}
                value={formik.values?.saleDate ? dayjs(formik.values.saleDate, 'YYYY-MM-DD') : null}
                format='MMM-DD-YYYY'
              />
            </div>
          </div>
          <div className="col-md-6">
            <label className="input-label">
              Sales Representative <span className="text-danger"> *</span>
            </label>
            <Select
              styles={customStyles}
              className="select"
              options={getallActiveUsers?.result?.
                map((option: any) => ({
                  label: option?.userName,
                  value: option?.userId
                }))}
              value={
                formik.values?.lst_SaleRepresentative?.id
                  ? {
                    value: formik.values?.lst_SaleRepresentative?.id,
                    label: formik.values?.lst_SaleRepresentative?.value || '',
                  }
                  : null
              }
              onChange={(selectedOption: any) => {
                formik.setFieldValue('lst_SaleRepresentative.id', selectedOption.value);
                formik.setFieldValue('lst_SaleRepresentative.value', selectedOption.label);
              }}
              isDisabled={saleInfoData?.result?.lst_SaleRepresentative?.id !== null}

            />
          </div>
          <div className="col-md-6">
            <label className="input-label">
              Follow Up Sales Representative
            </label>
            <Select
              styles={customStyles}
              className="select"
              options={getallActiveUsers?.result?.
                map((option: any) => ({
                  label: option?.userName,
                  value: option?.userId
                }))}
              value={
                formik.values?.lst_FollowUpSale?.id
                  ? {
                    value: formik.values?.lst_FollowUpSale?.id,
                    label: formik.values?.lst_FollowUpSale?.value || '',
                  }
                  : null
              }
              onChange={(selectedOption: any) => {
                formik.setFieldValue('lst_FollowUpSale.id', selectedOption.value);
                formik.setFieldValue('lst_FollowUpSale.value', selectedOption.label);
              }}
              isDisabled={saleInfoData?.result?.lst_FollowUpSale?.id !== null}

            />
          </div>
          <h5 className='mb-2 mt-2'>Payment Schedule</h5>
          <div className='col-md-5'></div>
          <div className='col-md-7'>
            <div className="col-md-12">
              <div className="form-wrap">
                <TextField
                  leftLabel="Sale Price"
                  type="text"
                  fieldClass='text-end'
                  // value={formik.values?.salePrice ? formik.values?.salePrice.toFixed(2).toLocaleString() : 0.00}
                  value={formik.values?.salePrice === 0 ? '' : formik?.values?.salePrice}
                  onChange={handleSalePriceChange}
                  // onBlur={handleSalePriceBlur}
                  disabled={saleInfoData?.result?.salePrice !== null}
                  required
                // {...formik.getFieldProps("salePrice")}
                />
              </div>
            </div>
            <div className="col-md-12 mb-2">
              <div className='d-flex justify-content-between'>
                <div className='input-label '>
                  Total Addenda Amount
                </div>
                <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                  <FormattedNumber value={formik.values?.totalAdendum} />
                </div>
              </div>
            </div>
            <div className="col-md-12 mb-2">
              <div className='d-flex justify-content-between'>
                <div className='input-label '>
                  Total Contract Amount
                </div>
                <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                  <FormattedNumber value={formik.values?.totalContractAmt} />
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className='d-flex justify-content-between'>
                <div className='input-label '>
                  Total Payment Distribution
                </div>
                <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                  <FormattedNumber value={formik.values?.totalPaymentAmt} />
                </div>
              </div>
            </div>
            <div className='col-md-12'></div>
            <div className="col-md-12 mt-2 w-100 d-flex justify-content-end text-end">
              <div className='br-gray py-2 px-3 w-50'>
                <p className='color-red fs-15 fw-600'>{<FormattedNumber value={remainingAmountFormatted} />}</p>

              </div>
            </div>
            {parseFloat(remainingAmount.replace(/,/g, '')) < 0 && (
              <p className="color-red fw-semibold d-flex justify-content-end">
                Negative amount not considered
              </p>
            )}
          </div>
          {isDuplicateOrderId &&
            <p className="color-red">
              Order Id's cant be same
            </p>}
          {/* <div className='col-md-2'>
          <div className='d-flex justify-content-center mt-4'>
            <button className='btn btn-primary py-2'>Recalculate</button>
          </div>
        </div> */}
          {/* table */}
          <div className='col-md-12 '>
            <div className="table-responsive mt-2 overflow-auto">
              <table className="table dataTable no-footer table-hover">
                <thead>
                  <tr>
                    <th className='p-0'>
                      Order
                    </th>
                    <th className='p-0'>
                      Payment Type
                    </th>
                    <th className='p-0'>
                      Payment Amt
                    </th>
                    <th className='p-0'>
                      Change By
                    </th>
                    <th className='p-0'>
                      New Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {formik?.values?.projectPaymentSchedule?.map((item: any, index: any) => {
                    const selectedOption = optionsOrderId.find(
                      (option) => option.value === item.orderId
                    )
                    return (
                      <tr key={item.id}>
                        <Select
                          styles={customStyles}
                          className="select payment-select p-0"
                          options={optionsOrderId}
                          value={selectedOption || null}
                          menuPlacement="top"
                          menuPosition="fixed"

                          // onChange={(selectedOption: any) => {
                          //   formik.setFieldValue(`[${index}].orderId`, selectedOption?.value || "");
                          // }}
                          onChange={(selectedOption: any) => {
                            if (selectedOption?.value) {
                              handleOrderIdChange(index, selectedOption.value);
                            }
                          }}
                        />
                        <td className='p-0 px-3'>{item.lst_PaymentType.value}</td>
                        <td className='text-center p-0 px-3'>
                          {/* {item.paymentAmt !== 0 ? item.paymentAmt?.toFixed(2)?.toLocaleString() : "0.00"} */}
                          <FormattedNumber value={item?.paymentAmt} />
                        </td>
                        <td className='text-end p-0'>
                          <input
                            type="text"
                            className="form-control payment-changeby text-end"
                            value={formik.values?.projectPaymentSchedule?.[index]?.changeBy === 0 ? "" : formik.values?.projectPaymentSchedule?.[index]?.changeBy ?? ""}
                            onChange={(e) => {
                              const rawValue = e.target.value.replace(/,/g, "");
                              if (/^-?\d*\.?\d*$/.test(rawValue) || rawValue === "-" || rawValue === "") {
                                // Always update with raw input
                                formik.setFieldValue(`projectPaymentSchedule[${index}].changeBy`, rawValue);

                                if (!isNaN(Number(rawValue)) && rawValue !== "-" && rawValue !== "") {
                                  const numericValue = Number(rawValue);

                                  formik.setFieldValue(`projectPaymentSchedule[${index}].orderId`, item.orderId);
                                  formik.setFieldValue(`projectPaymentSchedule[${index}].lst_PaymentType.id`, item.lst_PaymentType?.id);
                                  formik.setFieldValue(
                                    `projectPaymentSchedule[${index}].newAmount`,
                                    numericValue + (formik.values?.projectPaymentSchedule?.[index]?.paymentAmt || 0)
                                  );
                                } else {
                                  // Optional: Reset newAmount if raw value is empty or invalid
                                  formik.setFieldValue(
                                    `projectPaymentSchedule[${index}].newAmount`,
                                    formik.values?.projectPaymentSchedule?.[index]?.paymentAmt || 0
                                  );
                                }
                              }
                            }}
                            onBlur={(e) => {
                              const rawVal = e.target.value.replace(/,/g, "");
                              const finalValue = rawVal && !isNaN(Number(rawVal)) ? Number(rawVal) : "";
                              formik.setFieldValue(`projectPaymentSchedule[${index}].changeBy`, finalValue);
                            }}
                          />
                        </td>
                        {/* <td className='text-end'>{formik.values.projectPaymentSchedule[index]?.newAmount !== 0 ? formik.values.projectPaymentSchedule[index]?.newAmount?.toFixed(2)?.toLocaleString() : "0.00"}</td> */}
                        <td className='text-center p-0 px-3'> <FormattedNumber value={formik.values.projectPaymentSchedule[index]?.newAmount} /></td>
                        <td className="p-0">
                          {item.id === "00000000-0000-0000-0000-000000000000" && item.lst_PaymentType?.id !== 14 && (
                            <button
                              type="button"
                              className="btn btn-sm btn-primary"
                              onClick={() => handleDeleteEntry(item.orderId)}
                            >
                              {svgIcons.DeleteIcon}
                            </button>
                          )}
                        </td>
                      </tr>
                    )
                  }
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {/* new table row */}
          <h5 className='mt-2 mb-2'>Add New Payment</h5>
          <div className='d-flex gap-2'>
            <div className="col-md-1">
              <Select
                styles={customStyles}
                className="select payment-select"
                options={optionsOrderId}
                value={maxOrderId ? { label: `${maxOrderId}`, value: maxOrderId } : null}
                menuPlacement="top"
                menuPosition="fixed"
                isDisabled
              // onChange={(selectedOption: any) => {
              //   formik.setFieldValue(`[${index}].orderId`, selectedOption?.value || "");
              // }}
              />
            </div>
            <div className="col-md-4 mb-3">
              <Select
                styles={customStyles}
                className="select payment-select"
                options={projectLookups?.result?.
                  Lst_PaymentSchedule?.map((option: any) => ({
                    label: option?.value,
                    value: option?.id
                  }))}
                value={
                  paymentType.id
                    ? { label: paymentType.value, value: paymentType.id }
                    : null
                }
                onChange={(selectedOption: any) => {
                  setPaymentType({ id: selectedOption.value, value: selectedOption.label });
                }}
                menuPlacement="top"
              />
            </div>
            <div className="col-md-4 mb-3">
              <div className='d-flex gap-3 align-items-end'>
                <p className='mb-0'>

                </p>
                <div className="form-wrap w-100 mb-0 d-flex align-items-center">
                  <p className='mb-0'>$</p>
                  <div className=' w-100'>
                    <TextField
                      type="text"
                      value={paymentAmt}
                      fieldClass='text-end payment-changeby'
                      // onChange={(e) => {
                      //   const amount = parseFloat(e.target.value) || 0;
                      //   setPaymentAmt(amount.toString());
                      // }}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^-?\d*\.?\d*$/.test(val) || val === '' || val === '-') {
                          setPaymentAmt(val);
                        }
                      }}
                    />
                  </div>
                </div>

              </div>
            </div>
            <div className='col-md-2 mb-3'>
              <div className='d-flex justify-content-center'>
                <button className='btn btn-primary px-3 py-2' onClick={handleTableChange}
                  disabled={
                    paymentType?.id === 0 &&
                    !paymentAmt ||
                    remainingAmount === '0'
                  }
                >
                  Add
                </button>
                {/* <button className='btn btn-light px-3 py-2' onClick={handleReset}>
              Reset
            </button> */}
              </div>
            </div>
          </div>
          {(paymentType?.value === "Other" || paymentType?.value === "On Date") && (
            <>
              <div className="row">
                {/* <div className="col-md-1">

                </div> */}
                <div className="col-md-9 " style={{ width: '845px' }}>
                  <div className="mb-2">
                    <label>Description <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={paymentDescription}
                      onChange={(e) => { setPaymentDescription(e.target.value); setConcatPaymentDescription(prev => `${paymentDescription}-${paymentDate}`.trim()) }}
                      placeholder="Enter description"
                    />
                  </div>
                </div>
              </div>

            </>
          )}
          {paymentType?.value === "On Date" && (
            <>
              <div className="row">
                {/* <div className="col-md-1">

                </div> */}
                <div className="col-md-9" style={{ width: '845px' }}>
                  <label>Date <span className="text-danger">*</span></label>
                  <div className="form-wrap icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control datetimepicker deals-details"
                      onChange={(date) => {
                        if (date) {
                          const selected = dayjs(date);
                          setPaymentDate(selected); // set actual date in date state
                          // Append formatted date to description
                          const formattedDate = selected?.format("MMM-DD-YYYY");
                          setConcatPaymentDescription(prev => `${paymentDescription} - ${formattedDate}`.trim());
                        }
                      }}
                      value={paymentDate || null}
                      format="MMM-DD-YYYY"
                      allowClear={false}
                    />
                  </div>
                </div>
              </div>

            </>
          )}
        </>

      </div>
    </>

  )
}

export default SalesInfoWizardData